import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';
import Button from '../../elements/Button';
import Text from '../../elements/Text';

function GuestSelectorItem(props) {
  const { label, count, dispatch, counter, controlButton } = props;
  const decreaseEnabled = count > 0;
  const handleIncrease = () => dispatch('INCREASE');
  const handleDecrease = () => dispatch('DECREASE');
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box display="flex" alignItems="center" paddingBottom="2" className={className} style={style}>
      <Text flexGrow="1" textAlign="left">
        {label}
      </Text>
      <Button
        disabled={!decreaseEnabled}
        cursor={decreaseEnabled ? 'pointer' : 'default'}
        onClick={handleDecrease}
        {...controlButton}
      >
        −
      </Button>
      <Box style={counter} display="flex" justifyContent="center" alignItems="center">
        <Text fontSize="4" paddingLeft="3">
          {count}
        </Text>
        <Text paddingLeft="1px" paddingRight="3">
          +
        </Text>
      </Box>
      <Button onClick={handleIncrease} {...controlButton}>
        +
      </Button>
    </Box>
  );
}

GuestSelectorItem.propTypes = {
  /**
   * Count
   */
  count: PropTypes.number,
  /**
   * Max length allowed
   */
  label: PropTypes.string,
  /**
   * Dispatch function ({ type: 'INCREASE' | 'DECREASE' })
   */
  dispatch: PropTypes.func,
  /**
   * Counter styles
   */
  counter: PropTypes.objectOf(PropTypes.any),
  /**
   * Control button settings
   */
  controlButton: PropTypes.objectOf(PropTypes.any),
};

GuestSelectorItem.defaultProps = {
  count: 0,
  label: '',
  dispatch: () => {},
  counter: {
    minWidth: 70,
  },
  controlButton: {},
};

export default GuestSelectorItem;
